/* Levano · gallery scrolling on colour change
   1. The buy box calls scrollIntoView() on the active thumbnail. With the page as
      the nearest scroll container that drags the window down to the strip, which
      lands the shopper in the product text. Here it scrolls the strip itself and
      never moves the page.
   2. Picking a colour anywhere (buy box or a bundle row) brings the main image
      back into view, but only when the gallery is mostly off-screen. */
(function(){
  var THUMB='.lvf-gal__thumb', STRIP='.lvf-gal__thumbs', GAL='.lvf-gal';
  var native=Element.prototype.scrollIntoView;

  /* the strip has scroll-behavior:smooth and scroll-snap, so a plain scrollLeft
     assignment can be swallowed: set it with smoothing off, then restore */
  function setScroll(el,prop,value){
    var prev=el.style.scrollBehavior;
    el.style.scrollBehavior='auto';
    el[prop]=value;
    el.style.scrollBehavior=prev||'';
  }

  function centreInStrip(el,strip){
    var t=el.getBoundingClientRect(),s=strip.getBoundingClientRect();
    if(strip.scrollWidth-strip.clientWidth>2){
      var want=strip.scrollLeft+(t.left-s.left)-(s.width-t.width)/2;
      want=Math.max(0,Math.min(want,strip.scrollWidth-strip.clientWidth));
      if(Math.abs(want-strip.scrollLeft)>1){
        if(strip.scrollTo)strip.scrollTo({left:want,behavior:'smooth'});
        (function(target){setTimeout(function(){
          if(Math.abs(strip.scrollLeft-target)>2)setScroll(strip,'scrollLeft',target);
        },380)})(want);
      }
    }
    if(strip.scrollHeight-strip.clientHeight>2){
      var wantY=strip.scrollTop+(t.top-s.top)-(s.height-t.height)/2;
      wantY=Math.max(0,Math.min(wantY,strip.scrollHeight-strip.clientHeight));
      if(Math.abs(wantY-strip.scrollTop)>1){
        if(strip.scrollTo)strip.scrollTo({top:wantY,behavior:'smooth'});
        (function(target){setTimeout(function(){
          if(Math.abs(strip.scrollTop-target)>2)setScroll(strip,'scrollTop',target);
        },380)})(wantY);
      }
    }
  }

  /* ---- 1. keep thumbnail scrolling inside the strip ---- */
  Element.prototype.scrollIntoView=function(){
    try{
      if(this.matches&&this.matches(THUMB)){
        var strip=this.closest(STRIP);
        if(strip){centreInStrip(this,strip);return}
      }
    }catch(e){}
    return native.apply(this,arguments);
  };

  /* ---- 2. bring the images back when a colour is picked ---- */
  function headerOffset(){
    var h=document.querySelector('.section-header');
    return (h?h.getBoundingClientRect().height:0)+16;
  }
  function visibleShare(el){
    var r=el.getBoundingClientRect();
    if(!r.height)return 1;
    var vis=Math.max(0,Math.min(r.bottom,window.innerHeight)-Math.max(r.top,0));
    return vis/r.height;
  }
  var pending=null;
  function revealGallery(){
    clearTimeout(pending);
    pending=setTimeout(function(){
      var gal=document.querySelector(GAL);
      if(!gal)return;
      if(visibleShare(gal)>0.5)return;                 /* already looking at it */
      gal.style.scrollMarginTop=headerOffset()+'px';
      try{ native.call(gal,{block:'start',behavior:'smooth'}); }
      catch(e){ native.call(gal,true); }
      setTimeout(function(){
        if(visibleShare(gal)<0.5){
          var se=document.scrollingElement||document.documentElement;
          setScroll(se,'scrollTop',Math.max(0,se.scrollTop+gal.getBoundingClientRect().top-headerOffset()));
        }
      },700);
    },160);
  }

  function isColourControl(el){
    return !!(el&&el.closest&&(el.closest('.lvf-swatch')||el.closest('.lvb-tile')));
  }

  document.addEventListener('click',function(e){
    if(isColourControl(e.target))revealGallery();
  },true);

  document.addEventListener('change',function(e){
    var sel=e.target;
    if(sel&&sel.tagName==='SELECT'&&sel.closest&&sel.closest('.lvf-form'))revealGallery();
  },true);
})();
